import React, {
  useEffect,
} from 'react';

import {
  useTranslation,
} from 'react-i18next';

import BrandSection
  from '../components/BrandSection';

import FindAccountSection
  from '../components/FindAccountSection';

import './FindAccountPage.css';

export default function FindAccountPage() {
  const {
    t,
    i18n,
  } =
    useTranslation(
      'common',
    );

  useEffect(() => {
    document.title =
      t('meta.title');
  }, [
    t,
    i18n.resolvedLanguage,
  ]);

  return (
    <main className="login-page">
      <BrandSection/>

      <FindAccountSection />
    </main>
  );
}